import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectors } from 'PhenotypeView/store/selectors';
import { setTableSortBy, setTablePageSize } from 'PhenotypeView/store/slice';
import TableSection from './TableSection';
const TableSectionContainer = ({ levelResult, columns, scrollThreshold, onStickyChange, visibleColumns, onConfigChange, onConfigUnHide, onConfigReset, }) => {
    const dispatch = useDispatch();
    const { getTableData, getTableSettings } = getSelectors(levelResult);
    const data = useSelector(getTableData);
    const { sortBy, pageSize } = useSelector(getTableSettings);
    const handleSortByChange = useCallback((columnId, sortType) => {
        dispatch(setTableSortBy({ columnId, sortType, levelResult }));
    }, [dispatch, levelResult]);
    const handlePageSizeChange = useCallback((updatedPageSize) => {
        dispatch(setTablePageSize({ pageSize: updatedPageSize, levelResult }));
    }, [dispatch, levelResult]);
    return (_jsx(TableSection, { data: data, onPageSizeChange: handlePageSizeChange, onSortByChange: handleSortByChange, pageSize: pageSize, sortBy: sortBy, columns: columns, scrollThreshold: scrollThreshold, onStickyChange: onStickyChange, visibleColumns: visibleColumns, onConfigChange: onConfigChange, onConfigUnHide: onConfigUnHide, onConfigReset: onConfigReset }, void 0));
};
export default memo(TableSectionContainer);
